import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { CircleNotifications, ShoppingCart } from "@mui/icons-material";
import {
  Badge,
  Container,
  Divider,
  Drawer,
  List,
  Tooltip,
  styled,
} from "@mui/material";
import { useCart } from "../Context/CartContext";
import { Link, NavLink } from "react-router-dom";
import { useParams } from "react-router-dom";
import MoveToTop from "../MoveToTop";

const MenuListBox = styled(Box)(({ theme }) => ({
  color: "#fff",
  display: "flex",
  gap: "15px",
  alignItems: "center",
  [theme.breakpoints.down("md")]: {
    "& span": {
      display: "none",
    },
  },
}));

const CustomDrawer = styled(Drawer)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "none",
  },
  "& .MuiPaper-root": {
    background: theme.palette.primary.main,
    color: "#fff",
  },
  "& ul": {
    padding: "20px",
  },
}));

export default function Navbar() {

  let { id } = useParams();
  const [openDrawer, setOpenDrawer] = React.useState(false);

  id = id || `3R400`;
  const [id1, setId1] = React.useState(id);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setOpenDrawer(open);
  };

  const list = (anchor) => (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <NavLink
          to={`/warehouse/${id1}`}
          style={({ isActive, isPending }) => {
            return {
              backgroundColor: isActive ? "#0000001a" : "inherit",
              padding: "5px 13px",
              borderRadius: "3px",
              display: "block",
            };
          }}
        >
          ROF
        </NavLink>
        {/* <Link to={`/warehouse/${id}`}>ROF</Link> */}
      </List>
      <Divider />
      <List>
        <NavLink
          to={`/fittings/${id1}`}
          style={({ isActive, isPending }) => {
            return {
              backgroundColor:
                (isActive || window.location.pathname.startsWith("/pos/fittings/"))
                  ? "#0000001a"
                  : "inherit",
              padding: "5px 13px",
              borderRadius: "3px",
              display: "block",
            };
          }}
        >
          Fittings Orders
        </NavLink>
        <Link to="/fittings">Fittings Orders</Link>
      </List>
      {/* <Divider /> */}
      <List>
        {/* <NavLink
          to={`/warehouse_orders/${id1}`}
          style={({ isActive, isPending }) => {
            return {
              backgroundColor:
                (isActive || window.location.pathname.startsWith("/pos/warehouse_orders/"))
                  ? "#0000001a"
                  : "inherit",
              padding: "5px 13px",
              borderRadius: "3px",
              display: "block",
            };
          }}
        >
          Order Fulfillment
        </NavLink> */}
      </List>
    </Box>
  );

  //const cartValue = useCart();
  return (
    <Box sx={{ flexGrow: 1, marginBottom: "50px" }}>
      <MoveToTop />
      <AppBar position="static">
        <Container maxWidth="xl">
          <Toolbar
            disableGutters
            style={{
              display: "flex",
              alignItem: "center",
              justifyContent: "space-between",
            }}
          >
            <MenuListBox>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={toggleDrawer("left", true)}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="p" sx={{ flexGrow: 1 }}>
                <NavLink
                  to={`/warehouse/${id1}`}
                  style={({ isActive, isPending }) => {
                    return {
                      backgroundColor: isActive ? "#0000001a" : "inherit",
                      padding: "5px 13px",
                      borderRadius: "3px",
                    };
                  }}
                >
                  ROF
                </NavLink>
              </Typography>

              <Typography variant="p" sx={{ flexGrow: 1 }}>
                <NavLink
                  to={`/fittings/${id1}`}
                  style={({ isActive, isPending }) => {
                    return {
                      backgroundColor:
                        (isActive || window.location.pathname.startsWith("/pos/fittings/"))
                          ? "#0000001a"
                          : "inherit",
                      padding: "5px 13px",
                      borderRadius: "3px",
                    };
                  }}
                >
                  Fittings Orders
                </NavLink>
              </Typography>

              {/* <Typography variant="p" sx={{ flexGrow: 1 }}>
                <NavLink
                  to={`/warehouse_orders/${id1}`}
                  style={({ isActive, isPending }) => {
                    return {
                      backgroundColor:
                        (isActive || window.location.pathname.startsWith("/pos/warehouse_orders/"))
                          ? "#0000001a"
                          : "inherit",
                      padding: "5px 13px",
                      borderRadius: "3px",
                    };
                  }}
                >
                  Order Fulfillment
                </NavLink>
              </Typography> */}
            </MenuListBox>
            {/* {!window.location.pathname.startsWith("/pos/warehouse_orders/") &&
              <Box>
                <Typography variant="p" sx={{ flexGrow: 1 }}>
                  <NavLink
                    to={`/order_history/${id1}`}
                    style={({ isActive, isPending }) => {
                      return {
                        backgroundColor: isActive ? "#0000001a" : "inherit",
                        padding: "5px 13px",
                        borderRadius: "3px",
                      };
                    }}
                  >
                    Order History
                  </NavLink>
                </Typography>
              </Box>
            } */}
          </Toolbar>
        </Container>
      </AppBar>

      <CustomDrawer
        color="primary"
        anchor={"left"}
        open={openDrawer}
        onClose={toggleDrawer("left", false)}
      >
        {list("left")}
      </CustomDrawer>
    </Box>
  );
}
